export const removeItem = <T>(at: number, arr: T[]): T[] =>
  arr.filter((_, index) => index !== at);
